import { fromArrayLike } from './from';
export function of() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return fromArrayLike(values);
}
//# sourceMappingURL=of.js.map